import * as React from 'react';
import './assets/index.css';
import isFunction from 'lodash/isFunction';

interface IToggleSwitchState {
	on: boolean;
	enabled: boolean;
}

export enum ToggleStyle {
	AllowedToEdit = 'default-small',
	NotAllowedToEdit = 'graphite-small'
}

interface IToggleSwitchProps {
	toggleIndex?: number;
	on: boolean;
	enabled: boolean;
	label?: string;
	onChange?: Function;
	toggle: ToggleStyle;
	groupName?: string;
}

export default class ToggleSwithc extends React.Component<IToggleSwitchProps, IToggleSwitchState> {
	constructor(props) {
		super(props);
		this.state = {
			on: this.props.on,
			enabled: this.props.enabled
		};
	}

	toggleSwitch = () => {
		
				const { toggleIndex, onChange, label, groupName } = this.props;
				const on = !this.props.on;
				const onChangeProps = {
					toggleIndex: toggleIndex,
					label: label,
					on: on,
					groupName: groupName
				};
				isFunction(onChange) && onChange(onChangeProps);		
	};

	render() {
		return (
			<React.Fragment>
				<div key={this.props.groupName+this.props.label+this.props.enabled}
					className={'switch switch--' + this.props.toggle}
					onClick={this.props.enabled ? this.toggleSwitch : null}
				>
					<div className={`switch-toggle switch-toggle--${this.props.on ? 'on' : 'off'}`} />
					<div className="switch-label" dangerouslySetInnerHTML={{__html: this.props.label}}></div>
				</div>
			</React.Fragment>
		);
	}
}
